import styled, { css } from 'styled-components'

export default {
  adaptive: {
    lg: '@media screen and (max-width: 1330px)',
    sm: '@media screen and (max-width: 780px)',
    xsm: '@media screen and (max-width: 540px)',
    partners: {
      lg: '@media screen and (max-width: 1330px)',
    },
    index: {
      xl: '@media screen and (max-width: 1850px)',
      lg: '@media screen and (max-width: 1650px)',
      md: '@media screen and (max-width: 1300px)',
      smd: '@media screen and (max-width: 1060px)',
      sm: '@media screen and (max-width: 830px)',
      smm: '@media screen and (max-width: 380px)',
      preview: {
        lg: '@media screen and (max-width: 1060px)',
        md: '@media screen and (max-width: 920px)',
      },
      main: {
        xl: '@media screen and (max-width: 1850px)',
        lg: '@media screen and (max-width: 1650px)',
        slg: '@media screen and (max-width: 1400px)',
        md: '@media screen and (max-width: 1200px)',
      },
    },
    forms: {
      lg: '@media screen and (max-width: 1330px), screen and (max-height: 820px)',
      md: '@media screen and (max-width: 1000px), screen and (max-height: 740px)',
      sm: '@media screen and (max-width: 780px)',
    },
    headerMenu: {
      xl: '@media screen and (max-width: 1680px)',
      lg: '@media screen and (max-width: 1440px), screen and (max-height: 820px)',
      slg: '@media screen and (max-width: 1240px), screen and (max-height: 780px)',
      md: '@media screen and (max-width: 920px), screen and (max-height: 580px)',
      sm: '@media screen and (max-width: 620px)',
      smm: '@media screen and (max-width: 360px), screen and (max-width: 620px) and (max-height: 749px)',
    },
    headerMenuWhite: {
      xl: '@media screen and (max-width: 1680px)',
      lg: '@media screen and (max-width: 1440px), screen and (max-height: 820px)',
      slg: '@media screen and (max-width: 1240px), screen and (max-height: 780px)',
      md: '@media screen and (max-width: 920px), screen and (max-height: 700px)',
      sm: '@media screen and (max-width: 620px), screen and (max-height: 600px)',
      smm: '@media screen and (max-width: 360px), screen and (max-width: 620px) and (max-height: 749px)',
    },
    newIndex: {
      xl: '@media screen and (max-width: 1750px)',
      lg: '@media screen and (max-width: 1500px)',
      md: '@media screen and (max-width: 1300px)',
      smd: '@media screen and (max-width: 1100px)',
      sm: '@media screen and (max-width: 800px)',
      smm: '@media screen and (max-width: 420px)',
    },
    newFundraising: {
      xl: '@media screen and (max-width: 1850px)',
      lg: '@media screen and (max-width: 1650px)',
      md: '@media screen and (max-width: 1400px)',
      smd: '@media screen and (max-width: 1200px)',
      sm: '@media screen and (max-width: 880px)',
      smm: '@media screen and (max-width: 380px)',
    },
    olympus: {
      xl: '@media screen and (max-width: 1750px)',
      lg: '@media screen and (max-width: 1540px)',
      slg: '@media screen and (max-width: 1300px)',
      md: '@media screen and (max-width: 1100px)',
      smd: '@media screen and (max-width: 830px)',
      sm: '@media screen and (max-width: 620px)',
      ssm: '@media screen and (max-width: 374px)',
    },
    zeroTier: {
      xl: '@media screen and (max-width: 1800px)',
      lg: '@media screen and (max-width: 1540px)',
      slg: '@media screen and (max-width: 1300px)',
      md: '@media screen and (max-width: 1100px)',
      smd: '@media screen and (max-width: 830px)',
      sm: '@media screen and (max-width: 620px)',
      ssm: '@media screen and (max-width: 374px)',
    },
    olympusModal: {
      lg: '@media screen and (max-width: 1540px)',
      md: '@media screen and (max-width: 1100px)',
      sm: '@media screen and (max-width: 620px), screen and (max-height: 810px)',
      ssm: '@media screen and (max-width: 400px), screen and (max-height: 540px)',
    },
    dashboard: {
      xxl: '@media screen and (max-width: 1920px)',
      xl: '@media screen and (max-width: 1680px)',
      lg: '@media screen and (max-width: 1440px)',
      md: '@media screen and (max-width: 1280px)',
      sm: '@media screen and (max-width: 919px)',
    },
    occamx: {
      xl: '@media screen and (max-width: 1850px)',
      lg: '@media screen and (max-width: 1650px)',
      slg: '@media screen and (max-width: 1300px)',
      md: '@media screen and (max-width: 1160px)',
      smd: '@media screen and (max-width: 880px)',
      sm: '@media screen and (max-width: 600px)',
      smm: '@media screen and (max-width: 420px)',
    },
    newDesign: {
      xl: '@media screen and (max-width: 1950px)',
      lg: '@media screen and (max-width: 1660px)',
      slg: '@media screen and (max-width: 1420px)',
      md: '@media screen and (max-width: 1260px)',
      sm: '@media screen and (max-width: 860px)',
      smm: '@media screen and (max-width: 580px)',
      xs: '@media screen and (max-width: 370px)',
    },
    newHomePage: {
      lg: '@media screen and (max-width: 1540px)',
      slg: '@media screen and (max-width: 1440px)',
      md: '@media screen and (max-width: 1080px)',
      sm: '@media screen and (max-width: 790px)',
      smm: '@media screen and (max-width: 560px)',
      xs: '@media screen and (max-width: 390px)',
    },
    popUp: {
      xl: '@media screen and (max-width: 1950px), screen and (max-height: 1150px)',
      lg: '@media screen and (max-width: 1660px), screen and (max-height: 990px)',
      slg: '@media screen and (max-width: 1420px), screen and (max-height: 860px)',
      md: '@media screen and (max-width: 1260px), screen and (max-height: 740px)',
    },
  },
}

export const getSphereAdaptive = (windowWidth: number) => {
  if (windowWidth <= 830) return 'sm'
  else if (windowWidth <= 1200) return 'md'
  else if (windowWidth <= 1400) return 'slg'
  else if (windowWidth <= 1650) return 'lg'
  else if (windowWidth <= 1850) return 'xl'
  else return 'max'
}

export const getAnimationAdaptive = (windowWidth: number) => {
  if (windowWidth <= 370) return 'xs'
  else if (windowWidth <= 580) return 'smm'
  else if (windowWidth <= 800) return 'xsm'
  else if (windowWidth <= 860) return 'sm'
  else if (windowWidth <= 1260) return 'md'
  else if (windowWidth <= 1420) return 'slg'
  else if (windowWidth <= 1660) return 'lg'
  else if (windowWidth <= 1950) return 'xl'
  else return 'max'
}

export const Container = styled.div`
  position: relative;
  width: 1200px;
  margin: 0 auto;
  ${({ theme }) => theme.adaptive.newHomePage.lg} {
    width: 1028px;
  }
  ${({ theme }) => theme.adaptive.newHomePage.slg} {
    width: 885px;
  }
  ${({ theme }) => theme.adaptive.newHomePage.md} {
    width: 656px;
  }
  ${({ theme }) => theme.adaptive.newHomePage.sm} {
    width: 520px;
  }
  ${({ theme }) => theme.adaptive.newHomePage.smm} {
    width: 350px;
  }
  ${({ theme }) => theme.adaptive.newHomePage.xs} {
    width: 260px;
  }
`

export const TitleCss = css`
  font-family: 'NeueHaasDisplay';
  font-weight: 200;
  font-size: 76px;
  line-height: 91px;
  letter-spacing: -0.03em;
  color: #27303b;
  ${({ theme }) => theme.adaptive.newHomePage.lg} {
    font-size: 65px;
    line-height: 78px;
  }
  ${({ theme }) => theme.adaptive.newHomePage.slg} {
    font-size: 56px;
    line-height: 67px;
  }
  ${({ theme }) => theme.adaptive.newHomePage.md} {
    font-size: 42px;
    line-height: 50px;
  }
  ${({ theme }) => theme.adaptive.newHomePage.sm} {
    font-size: 62px;
    line-height: 74px;
  }
  ${({ theme }) => theme.adaptive.newHomePage.xs} {
    font-size: 46px;
    line-height: 55px;
  }
`
